module.exports = __webpack_public_path__ + "img-dashboard/register/web-cv-gamping.5971a10b.png";